import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const exportPlanDesign = ({ groupId, benefitIds, exportBenefitIds }) =>
  call(websocketFetch, 'export_plan_design_to_spreadsheet', {
    group_id: groupId,
    benefit_ids: benefitIds,
    export_benefit_ids: exportBenefitIds,
  });
